import { Dialog } from '@spiaggeit/spit-ui'
import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { LoaderTrigger } from '@/components/LoaderTrigger'
import { useAppSelector } from '@/hooks/store.ts'
import { isKioskSelector } from '@/store/appSlice'
import { isLoadingLicenseStringSelector } from '@/store/licenseSlice/selectors/isLoadingLicenseStringsSelector'
import { serviceCostsStringSelector } from '@/store/licenseSlice/selectors/serviceCostsStringSelector'

type Props = React.PropsWithChildren
export const ServiceCostDialog = memo(function ServiceCostDialog(props: Props) {
  const { t } = useTranslation()
  const isKiosk = useAppSelector(isKioskSelector)
  const serviceCostsString = useAppSelector(serviceCostsStringSelector)
  const isLoading = useAppSelector(isLoadingLicenseStringSelector)

  if (isLoading) {
    return (
      <>
        <LoaderTrigger />
        <p>{t('map.elementDetail.serviceCost.title')}</p>
      </>
    )
  }

  return (
    <Dialog
      scrollContent
      size={isKiosk ? null : 'sm'}
      title={t('map.elementDetail.serviceCost.title')}
      trigger={props.children}
    >
      {serviceCostsString ? (
        <Content
          dangerouslySetInnerHTML={{
            __html: serviceCostsString.replace(/\n/g, '<br />'),
          }}
        />
      ) : (
        <Content>
          <p>{t('map.elementDetail.serviceCost.firstParagraph')}</p>

          <section>
            <h3 className="mb-1 font-bold">
              {t('map.elementDetail.serviceCost.secondParagraphTitle')}
            </h3>
            <p>{t('map.elementDetail.serviceCost.secondParagraphContent')}</p>
          </section>
        </Content>
      )}
    </Dialog>
  )
})

const Content = (props: React.ComponentPropsWithoutRef<'div'>) => {
  const { children, ...rest } = props

  return (
    <div
      className="flex flex-col items-stretch justify-between gap-4 p-4"
      {...rest}
    >
      {children}
    </div>
  )
}
